import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatLuxonDateModule, provideLuxonDateAdapter } from '@angular/material-luxon-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DateTime } from 'luxon';
import { MY_DATE_FORMATS, Registration } from '../../../domain/registrator';
import { RegistrationAddComponent } from '../registration-add/registration-add.component';

@Component({
  selector: 'app-payment-confirm',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatIconModule,
    MatRadioModule,
    MatTableModule,
    MatCardModule,
    MatListModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatTabsModule,
    MatDatepickerModule,
    MatSortModule,
    MatDialogModule,
    MatLuxonDateModule
  ],
  providers: [
    provideLuxonDateAdapter(),
    {
      provide: MAT_DATE_FORMATS,
      useValue: MY_DATE_FORMATS,
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'en-GB', // Or your desired locale
    },
  ],
  templateUrl: './payment-confirm.component.html',
  styleUrl: './payment-confirm.component.scss',
})
export class PaymentConfirmComponent {
  paymentForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<RegistrationAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { eventName: string, registration: Registration | null }) {
  }


  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm(): void {
    this.paymentForm = this.fb.group({
      date: [DateTime.now()],
      reference: ['', Validators.maxLength(64)],
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  onSave() {
    if (this.paymentForm.valid) {
      // const formValue: Registration = this.paymentForm.getRawValue();
      this.dialogRef.close(this.paymentForm.value);
    } else {
      this.markAllAsTouched(this.paymentForm);
    }
  }

  private markAllAsTouched(formGroup: FormGroup | FormArray): void {
    Object.values(formGroup.controls).forEach(control => {
      if (control instanceof FormGroup || control instanceof FormArray) {
        this.markAllAsTouched(control);
      } else {
        control.markAsTouched();
      }
    });
  }

}
